import React, { useContext, useEffect, useRef } from 'react';
import Table from 'react-bootstrap/Table';
import { ShopperContext } from '../context/shopper'
import { useStyles } from "../hooks/useStyles";
import { useUtils } from "../hooks/useUtils";
import { HeadingBuilder } from "../components/HeadingBuilder";
import { ClipboardButton } from "../components/ClipboardButton";
import Checkbox from "../components/Checkbox";
import * as Constants from '../constants';
import { useTranslation } from "react-i18next";

export const GoShopping = ({
    trip,
    handleGoShopClick,
    goShopList,
    showOrderBreakout,
    handleOrderBreakoutClick,
  }) => {

  const { signedIn, fetchSkus, fetchPrices,
          fetchTripDimSkus,
          fetchTripCartSkus } = useContext(ShopperContext);
  const { tableShow, textAlignLeft } = useStyles();
  const { getTripDateTimeLabel,
          transformShopListText,
            } = useUtils();
  const { t } = useTranslation();
  const tableRef = useRef(null);

  // Refresh checkbox and sku details between showings of 'Go Shopping' List.
  // For someone at home (or in the same/other store) viewing progress of
  // someone shopping, this gets accurate status updates upon doing hide/show
  // (refresh) of 'Go Shopping' List.
  useEffect(() => {
    fetchTripDimSkus();
    fetchTripCartSkus();
    fetchSkus();
    fetchPrices();
  }, [fetchTripDimSkus, fetchTripCartSkus, fetchSkus, fetchPrices]);

  const handleRefreshClick = (e) => {
    fetchTripCartSkus();
    fetchSkus();
    fetchPrices();
  };

  const orderBreakoutButtonTippyContent =
    showOrderBreakout
      ? t('trip.orderBreakoutButton.tippyContentWhenShowing')
        // Click this button to hide the Order breakouts.
      : t('trip.orderBreakoutButton.tippyContentWhenHiding');
        // Click this button for a breakout of what each Shopper ordered. // Clicking a Sku's label lets you change a Sku's details.

  const goShopClipboardHeading = 
    t('trip.formPart.shoppingTripPrompt') +
    ' ' +
    getTripDateTimeLabel({trip});

  const getGoShopClipboardText = () => {
    return (
      goShopClipboardHeading +
      "\n\n" +
      (tableRef.current?.innerText || "")
      // We need 'current?' to allow time for the ref to update properly.
    );
  };

  if (signedIn) {
    console.log('GoShopping.js goShopList: ', goShopList);

    return (
      <article>
        <hr/>
        <HeadingBuilder
          Size = 'h4'
          headingText = {t('trip.goShopping.headlineLabel')}
          // 'Go Shopping' List
          tippyAlertText = {t('trip.goShopping.tippyContent')}
          tippyText = {Constants.DOT}
          // You can use this listing of your group's plans as a shopping list in the store. If you check the box for each Sku you pick up, you will know what's in your cart and what you still have to get. // Clicking a Sku's label lets you change a Sku's details.
        />
        <b>{t('global.label.trip')+':'}</b>
          &nbsp;{ getTripDateTimeLabel({trip}) }
          {/* Trip: Oct 8, 2022,  2:00 PM,  Costco, Publix */}
        <br />
        <b>{t('global.label.circle')+':'}</b> {trip.circle.identifier}
          {/* Circle: am_circle */}
        <br />
        <div className="oneline-container">
          <button onClick={handleGoShopClick}>
            {t('trip.goShopping.hideListLabel')}
            {/* Hide this 'Go Shopping' List */}
          </button>
          <HeadingBuilder
            containerType  = 'container-input-label'
            buttonAction   = {handleRefreshClick}
            goButtonText   = {Constants.GET_ICON_REFRESH}
            tippyAlertText = {t('trip.goShopping.tippyContentRefresh')}
            tippyText      = {Constants.DOT}
          />
        </div>
        <br/>
        <Checkbox
          isChecked    = {showOrderBreakout}
          setIsChecked = {handleOrderBreakoutClick}
          label        = {t('trip.orderBreakoutButton.textToShow')}
          // Show who ordered what
          tippyAlert   = {orderBreakoutButtonTippyContent}
        />
        { goShopList
        ? <Table striped bordered hover size="sm" style={tableShow}>
          <thead>
            <tr>
              <td>
                <HeadingBuilder
                  containerType  = "container-left"
                  headingText    = {t('trip.goShopping.tableHeading')}
          // (inCart ckBox) amtToGet (dimmer) Brand, Name/Label, Price, UnitQty
                  tippyAlertText = {t('trip.goShopping.headingDefinitions')}
                  tippyText      = {Constants.DOT}
                  tippyInfoText  = {t('trip.goShopping.amtToGetTippyContent')}
                />
              </td>
            </tr>
          </thead>
          <tbody ref={tableRef} style={textAlignLeft}>
            {[goShopList.flat(1)]}
          </tbody>
          </Table>
        : <p>{t('ordersList.pageText.noOrderItemsDefined')}</p>
        }

        <div className="oneline-container">
          <button onClick={handleGoShopClick}>
            {t('trip.goShopping.hideListLabel')}
            {/* Hide this 'Go Shopping' List */}
          </button>
          <HeadingBuilder
            containerType  = 'container-input-label'
            buttonAction   = {handleRefreshClick}
            goButtonText   = {Constants.GET_ICON_REFRESH}
            tippyAlertText = {t('trip.goShopping.tippyContentRefresh')}
            tippyText      = {Constants.DOT}
          />
        </div>
        <br/>
        <Checkbox
          isChecked    = {showOrderBreakout}
          setIsChecked = {handleOrderBreakoutClick}
          label        = {t('trip.orderBreakoutButton.textToShow')}
          // Show who ordered what
          tippyAlert   = {orderBreakoutButtonTippyContent}
        />
        <br/>
          {tableRef.current && (
            <ClipboardButton
              buttonType    = 'goShoppingTable'
              getTextToCopy = {getGoShopClipboardText}
              xformTextFn   = {transformShopListText}
            />
          )}
        <hr/>
      </article>
    )
  } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
  }
}

export default GoShopping;
